import { render, staticRenderFns } from "./ItemOrder.vue?vue&type=template&id=73d0a553&lang=pug&"
import script from "./ItemOrder.vue?vue&type=script&lang=ts&"
export * from "./ItemOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ItemOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports